module.exports = __webpack_public_path__ + "img/Karl.87a2e555.jpeg";